<page-load-header *ngIf="!initialized"></page-load-header>

<div class="row mb-3">
  <div class="col-md-6">
    <div class="dropdown"><h4>My Exhibits</h4></div>
  </div>
  <div class="col-md-6 text-right">
    <!-- <button class="btn btn-primary" type="button" tabindex="0" [routerLink]="['../author-course']">Add a Poster</button> -->
  </div>
</div>
<div *ngIf="initialized">
  <div class="row no-gutters no-candidates" style="height: 300px" *ngIf="exhibits && exhibits.length == 0">
    <div class="col-sm-12 my-auto">
      <h1><i class="fas fa-empty-set"></i></h1>
      <h4>You don't have any upcoming exhibits.</h4>
      <p>If you think this is in error, please contact your conference administrator.</p>
    </div>
  </div>

  <div class="card">
    <div class="card-body p-4" *ngIf="exhibits && exhibits.length > 0">
      <!-- Activity Table -->
      <div class="table-responsive-md u-datatable">
        <table class="js-datatable table table-borderless u-datatable__striped u-datatable__content u-datatable__trigger mb-5" data-dt-info="#datatableInfo" data-dt-search="#datatableSearch" data-dt-entries="#datatableEntries" data-dt-page-length="12" data-dt-is-responsive="false" data-dt-is-show-paging="true" data-dt-details-invoker=".js-datatabale-details" data-dt-select-all-control="#invoiceToggleAllCheckbox" data-dt-pagination="datatablePagination" data-dt-pagination-classes="pagination mb-0" data-dt-pagination-items-classes="page-item" data-dt-pagination-links-classes="page-link" data-dt-pagination-next-classes="page-item" data-dt-pagination-next-link-classes="page-link" data-dt-pagination-next-link-markup='<span aria-hidden="true">&raquo;</span>' data-dt-pagination-prev-classes="page-item" data-dt-pagination-prev-link-classes="page-link" data-dt-pagination-prev-link-markup='<span aria-hidden="true">&laquo;</span>'>
          <thead>
            <tr class="text-uppercase font-size-1">
              <th scope="col" class="font-weight-medium">
                <div class="d-flex justify-content-between align-items-center">Title</div>
              </th>
              <th scope="col" class="font-weight-medium">
                <div class="d-flex justify-content-between align-items-center">Name</div>
              </th>
              <th scope="col" class="font-weight-medium">
                <div class="d-flex justify-content-between align-items-center">Type</div>
              </th>
              <th scope="col" class="font-weight-medium">
                <div class="d-flex justify-content-between align-items-center">Date</div>
              </th>

              <th scope="col" class="font-weight-medium">
                <div class="d-flex justify-content-between align-items-center">Actions</div>
              </th>
            </tr>
          </thead>
          <tbody class="font-size-1">
            <tr *ngFor="let exhibit of exhibits">
              <td class="align-middle font-weight-normal">
                <a *ngIf="!exhibit.isHybrid" [routerLink]="[exhibit.id, 'designer']">{{ exhibit.conferenceName }}</a>
                <a *ngIf="exhibit.isHybrid" [routerLink]="[exhibit.id, 'users']">{{ exhibit.conferenceName }}</a>
              </td>
              <td class="align-middle">{{ exhibit.title }}</td>
              <td class="align-middle">{{ exhibit.isHybrid | booleanToText: 'Hybrid':'Virtual' }}</td>
              <td class="align-middle text-secondary font-weight-normal">{{ exhibit.conferenceStartDate | date: 'shortDate' }} - {{ exhibit.conferenceEndDate | date: 'shortDate' }}</td>

              <td class="align-middle text-danger">
                <div class="dropdown">
                  <button class="btn btn-xs btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Actions</button>
                  <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                    <ng-container *ngIf="!exhibit.isHybrid">
                      <a class="dropdown-item" [routerLink]="[exhibit.id, 'designer']">Designer</a>
                      <a class="dropdown-item" [routerLink]="['/exhibitor-booth', exhibit.id, 'preview']">Preview</a>
                      <a class="dropdown-item" [routerLink]="['/exhibitor-booth', exhibit.id, 'dashboard']">Live Dashboard</a>
                    </ng-container>
                    <ng-container *ngIf="exhibit.isHybrid">
                      <a class="dropdown-item" [routerLink]="[exhibit.id, 'users']">Manage Users</a>
                      <a class="dropdown-item" href="api/exhibits/{{ exhibit.id }}/export?access_token={{ auth.getToken() }}">Export Visitors</a>
                    </ng-container>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- End Activity Table -->

      <!-- Pagination -->
      <div class="d-flex align-items-center">
        <nav id="datatablePagination" aria-label="Activity pagination"></nav>

        <small id="datatableInfo" class="text-secondary ml-auto"></small>
      </div>
      <!-- End Pagination -->
    </div>
  </div>
</div>
